import i18n from "../i18n";
import { Problem } from "../model/problem";

/**
 * Normalizes a slice's `error` (a plain string or a `Problem`) into a
 * title/details pair for the error modal.
 *
 * Guards against the "empty modal" case: when the backend returns an error with
 * no body (a 500/502/504, a gateway timeout, a bodyless 401/400, or a network
 * error), the slice ends up with an empty string — so we fall back to a generic
 * "Server Error" title instead of rendering a blank dialog.
 *
 * The fallback title is the only string we own here; `Problem.title` and
 * `Problem.detail` come from the API and are passed through untranslated.
 * Called from render paths rather than from a component, so it reads the
 * i18next singleton instead of taking a `t` parameter.
 */
export const getErrorMessage = (error?: string | Problem): { title: string; details: string } => {
    const fallbackTitle = i18n.t("error.server");

    if (typeof error === "string") {
        return { title: error || fallbackTitle, details: "" };
    }

    const apiError = error as Problem | undefined;
    return {
        title: apiError?.title ?? fallbackTitle,
        details: apiError?.detail ?? "",
    };
};
